import * as React from "react";
import { Trans } from "@lingui/react/macro";
import { AuthField } from "@app/ui/features/auth/AuthField";
import { HintTooltip } from "@app/ui/components/HintTooltip";

export interface PasswordFieldProps {
  id?: string;
  value: string;
  onChange: (value: string) => void;
  /** "새 비밀번호"처럼 라벨을 바꿔야 할 때 준다. 없으면 "비밀번호". */
  label?: React.ReactNode;
  /** 로그인은 "current-password", 가입/재설정은 "new-password". */
  autoComplete?: "current-password" | "new-password";
  /** 검증 실패 문구(이미 번역된 상태). react-hook-form 을 쓰는 화면이 넘겨준다. */
  error?: string;
  onBlur?: React.FocusEventHandler<HTMLInputElement>;
  required?: boolean;
  disabled?: boolean;
  className?: string;
}

const PasswordField = React.forwardRef<HTMLInputElement, PasswordFieldProps>(
  (
    {
      id = "password",
      value,
      onChange,
      label,
      autoComplete = "current-password",
      error,
      onBlur,
      required,
      disabled,
      className,
    },
    ref
  ) => {
    return (
      <AuthField
        ref={ref}
        id={id}
        name="password"
        type="password"
        autoComplete={autoComplete}
        label={label ?? <Trans>비밀번호</Trans>}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        // 문구를 입력 아래에 깔지 않고, 에러가 있을 때만 왼쪽 툴팁 아이콘으로 이유를 보여준다.
        // (hover/focus/터치 시 설명이 뜬다.) 빨간 테두리는 AuthField 가 error 로 처리.
        hideErrorText
        leftSlot={
          error ? <HintTooltip content={error} className="text-destructive" /> : undefined
        }
        required={required}
        disabled={disabled}
        className={className}
      />
    );
  }
);
PasswordField.displayName = "PasswordField";

export { PasswordField };
